module.exports = __webpack_public_path__ + "img/games-2.ff3f5b64.jpg";